import {folders_list_fixture} from './folders';
import {procedure_detail_fixture} from './procedure_detail';

import {DocumentSerializedType} from 'sweet-types';

let currentId = 0;

const getFolder = (folder_url) => {
  const folder = folders_list_fixture.results.filter(
    (folder) => folder.url === folder_url
  );

  if (folder.length === 0) {
    return null;
  }

  return folder[0];
};

export const createFakeDocument = (
  folder_url
): DocumentSerializedType | null => {
  currentId += 1;

  const folder = getFolder(folder_url);

  if (folder == null) {
    return null;
  }

  return {
    id: currentId,
    content_type: 'document',
    name: procedure_detail_fixture.name,
    document_content_type: 'procedure',
    object_id: procedure_detail_fixture.id,
    private: procedure_detail_fixture.private,
    folder: {
      id: folder.id,
      url: folder.url,
      content_type: 'basic_folder',
      hashid: folder.hashid,
      name: folder.name,
      html_url: folder.html_url,
      parent: null,
    },
    url: `https://local.sweetprocess.com/api/v1/documents/${currentId}/`,
    html_url: procedure_detail_fixture.html_url,
    document: {
      id: 1,
      url: procedure_detail_fixture.url,
      current_version: procedure_detail_fixture.current_version,
      hashid: procedure_detail_fixture.hashid,
      private: procedure_detail_fixture.private,
      embed_url: procedure_detail_fixture.embed_url,
      edited_at: procedure_detail_fixture.edited_at,
      approved_at: procedure_detail_fixture.approved_at,
      signoff_requested_at: procedure_detail_fixture.signoff_requested_at,
      signoff_requested_by: procedure_detail_fixture.signoff_requested_by,
      last_review_at: procedure_detail_fixture.last_review_at,
      next_review_at: procedure_detail_fixture.next_review_at,
      created_at: procedure_detail_fixture.created_at,
      tags: procedure_detail_fixture.tags,
      team_memberships: procedure_detail_fixture.team_memberships,
      team_names: procedure_detail_fixture.team_names,
    },
    can_assign: procedure_detail_fixture.can_assign,
    can_delete: procedure_detail_fixture.can_delete,
    can_edit: procedure_detail_fixture.can_edit,
    can_change: procedure_detail_fixture.can_change,
    can_export: procedure_detail_fixture.can_export,
    can_view: true,
  };
};

export const documents_list_fixture: DocumentSerializedType[] = [];
export const getDocumentList = (): DocumentSerializedType[] =>
  documents_list_fixture;
